import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../translation/translation';
import formatToCurrency from '../../../../_modules/currency/format_to_currency';
import getTranslatedText from '../../../helper/get_translated_text';
import { show as showDeliveryInfo } from '../../../../_flux/actions/catalog_delivery_info_light_box_actions';

const DeliveryEstimation = ({ daysTo, state, postcode, currencyIsoCode, amount, stock, productType, openPostcode }) => {
  let tyreShippingMessage;
  let wheelShippingMessage;
  let shippingAmount = formatToCurrency(amount, currencyIsoCode, true, true);
  let displayStockQty = stock < 4 ? stock : '4';
  const isWheel = productType === 'wheel';
  const type = isWheel ? 'wheels' : 'tyres';
  switch (daysTo) {
    case 0:
      tyreShippingMessage = 'product-shipping-delivery-today';
      wheelShippingMessage = 'product-shipping-delivery-wheels-today';
      break;
    case 1:
      tyreShippingMessage = 'product-shipping-delivery-next-day';
      wheelShippingMessage = 'product-shipping-delivery-next-day-wheels';

      break;
    default:
      tyreShippingMessage = 'product-shipping-delivery-day-estimate';
      wheelShippingMessage = 'product-shipping-delivery-day-estimate-wheels';
  }
  const productCategory = getTranslatedText(type).toLowerCase();
  return (
    <div className="shipping-fees__estimation">
      <Translation tagName="span" className="shipping-fees__cost" translationKey="product-shipping-delivery-ships" />

      {isWheel && (
        <>
          <Translation
            tagName="span"
            translationKey={'product-shipping-delivery-wheel-prefix'}
            placeholder={{ stockLocation: state }}
          />
          <span onClick={openPostcode} className="shipping-fees__link">
            {postcode}
          </span>
          <Translation tagName="span" translationKey={wheelShippingMessage} placeholder={{ estimation: daysTo }} />
        </>
      )}
      {!isWheel && (
        <Translation
          tagName="span"
          translationKey={tyreShippingMessage}
          placeholder={{ stockLocation: state, postCode: postcode, estimation: daysTo }}
        />
      )}

      {amount > 0 && (
        <Translation
          tagName="span"
          className="shipping-fees__cost"
          translationKey="product-shipping-delivery-with-fee"
          placeholder={{ amount: shippingAmount, stock: displayStockQty, productType: productCategory }}
        />
      )}

      <Translation
        tagName="span"
        className="shipping-fees__learn-more"
        style={{ color: '#3D83E1' }}
        translationKey="product-revamp-shipping-delivery-learn-more"
        onClick={openDetailLightBox}
      />
    </div>
  );
};

const openDetailLightBox = () => {
  return showDeliveryInfo();
};

DeliveryEstimation.propTypes = {
  amount: PropTypes.number.isRequired,
  stock: PropTypes.number.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  daysTo: PropTypes.number.isRequired,
  postcode: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
  openPostcode: PropTypes.func.isRequired,
};

export default DeliveryEstimation;
